import { render, staticRenderFns } from "./skuInfo.vue?vue&type=template&id=f1c192fe&scoped=true&"
import script from "./skuInfo.vue?vue&type=script&lang=js&"
export * from "./skuInfo.vue?vue&type=script&lang=js&"
import style0 from "./skuInfo.vue?vue&type=style&index=0&id=f1c192fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c192fe",
  null
  
)

export default component.exports